/**
 * File Tool Configurations
 *
 * Tools for file discovery and reading.
 */ import { defineToolConfig, formatCount, hasProperty } from '../tool-display-config';
const normalizeListFilesOutput = (output)=>{
    if (typeof output !== 'object' || output === null) return null;
    if ('files' in output && Array.isArray(output.files)) {
        return {
            files: output.files
        };
    }
    if ('success' in output && output.success === true && 'data' in output && typeof output.data === 'object' && output.data?.files && Array.isArray(output.data?.files)) {
        return {
            files: output.data.files
        };
    }
    return null;
};
// ============================================================================
// Tool Configurations
// ============================================================================
const listFilesConfig = defineToolConfig({
    id: 'list-files',
    aliases: [
        'listFilesTool',
        'listFiles'
    ],
    formatSuccess: (output)=>{
        const normalized = normalizeListFilesOutput(output);
        const count = normalized?.files?.length ?? 0;
        if (count === 0) return 'No files found';
        return `Found ${formatCount(count, 'file')}`;
    },
    formatError: (error)=>{
        if (hasProperty(error, 'message')) {
            return `Failed to list files: ${error.message}`;
        }
        return 'Failed to list files';
    },
    isValidOutput: (output)=>{
        return normalizeListFilesOutput(output) !== null;
    },
    isEmptyResult: (output)=>{
        const normalized = normalizeListFilesOutput(output);
        return !normalized?.files?.length;
    }
});
const readFileConfig = defineToolConfig({
    id: 'read-file',
    aliases: [
        'readFileTool',
        'readFile'
    ],
    formatSuccess: (output)=>{
        const name = output.name || 'file';
        if (output.totalLines && output.startLine !== undefined) {
            return `Read lines ${output.startLine}-${output.endLine} of ${name} (${output.totalLines} total lines)`;
        }
        return `Read ${name}`;
    },
    formatError: (error)=>{
        if (hasProperty(error, 'error')) {
            return `Failed to read file: ${error.error}`;
        }
        if (hasProperty(error, 'message')) {
            return `Failed to read file: ${error.message}`;
        }
        return 'Failed to read file';
    },
    formatInput: (input)=>{
        if (!input?.fileId) return [];
        const fields = [
            {
                label: 'File ID',
                value: input.fileId
            }
        ];
        if (input.startLine !== undefined) {
            fields.push({
                label: 'Lines',
                value: `${input.startLine}-${input.endLine ?? 'end'}`
            });
        }
        return fields;
    },
    isValidOutput: (output)=>{
        return typeof output === 'object' && output !== null && 'success' in output && 'fileId' in output && 'name' in output;
    },
    isErrorResult: (output)=>!output.success
});
export const fileToolConfigs = [
    listFilesConfig,
    readFileConfig
];
